"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _constructedForm = _interopRequireDefault(require("../styles/constructed-form.css"));
var _calendarPanel = _interopRequireDefault(require("./calendar-panel"));
var _errorMessage = _interopRequireDefault(require("./error-message"));
var _constructedForm2 = _interopRequireDefault(require("./constructed-form.props/constructed-form.defaultProps"));
var _constructedForm3 = _interopRequireDefault(require("./constructed-form.props/constructed-form.propTypes"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; } /**
 * ## DatePicker - component
 *
 * Some really cool piece of description goes here.
 */ // We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating
var keyMap = {
  tabKey: 9,
  rightArrow: 37,
  upArrow: 38,
  leftArrow: 39,
  downArrow: 40,
  returnKey: 13,
  spaceBar: 32,
  escKey: 27
};
var DatePicker = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(DatePicker, _React$Component);
  // All components need a resourceType in order for AEM to be aware of its existance
  DatePicker.resourceType = function resourceType() {
    return 'TextField_1_0_0';
  };
  DatePicker.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var dateString = state.dateString,
      isOverField = state.isOverField;
    if (dateString !== '' && isOverField) {
      return _objectSpread(_objectSpread({}, state), {}, {
        isOverField: false
      });
    }
    if (dateString === '' && !isOverField) {
      return _objectSpread(_objectSpread({}, state), {}, {
        isOverField: true
      });
    }
    return null;
  };
  function DatePicker(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var currentState = _this.state;
    var activeDate = props.value ? _this.stringToDate(currentState.dateString) : new Date();
    _this.state = {
      activeDate: activeDate,
      browseDate: activeDate,
      dateString: '',
      pickerExpanded: false,
      keyboardAccess: false,
      isOverField: true
    };
    _this.handlePrevClick = _this.handlePrevClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleNextClick = _this.handleNextClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.clickDateButtonHandler = _this.clickDateButtonHandler.bind((0, _assertThisInitialized2["default"])(_this));
    _this.focusDateButtonHandler = _this.focusDateButtonHandler.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDateTyping = _this.handleDateTyping.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDateInputFocus = _this.handleDateInputFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDateInputBlur = _this.handleDateInputBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyUp = _this.handleKeyUp.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setWrapper = _this.setWrapper.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = DatePicker.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this$wrapperRef;
    document.addEventListener('mousedown', this.handleClick, false);
    (_this$wrapperRef = this.wrapperRef) == null ? void 0 : _this$wrapperRef.addEventListener('keydown', this.handleKeyPress, false);
  };
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    var _this$state = this.state,
      activeDate = _this$state.activeDate,
      browseDate = _this$state.browseDate,
      pickerExpanded = _this$state.pickerExpanded;
    var _this$props = this.props,
      errorMessages = _this$props.errorMessages,
      value = _this$props.value;
    return nextProps.value !== value || !this.isSameArray(nextProps.errorMessages, errorMessages) || !this.compareDates(nextState.activeDate, activeDate) || !this.compareDates(nextState.browseDate, browseDate) || nextState.pickerExpanded !== pickerExpanded;
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    var _this$wrapperRef2;
    document.removeEventListener('mousedown', this.handleClick, false);
    (_this$wrapperRef2 = this.wrapperRef) == null ? void 0 : _this$wrapperRef2.removeEventListener('keydown', this.handleKeyPress, false);
  };
  _proto.handlePrevClick = function handlePrevClick(e) {
    e.preventDefault();
    var browseDate = this.state.browseDate;
    var updatedDate = new Date(browseDate);
    var currentMonth = browseDate.getMonth();
    updatedDate.setMonth(currentMonth - 1);
    this.setBrowseDate(updatedDate);
  };
  _proto.handleNextClick = function handleNextClick(e) {
    e.preventDefault();
    var browseDate = this.state.browseDate;
    var updatedDate = new Date(browseDate);
    var currentMonth = browseDate.getMonth();
    updatedDate.setMonth(currentMonth + 1);
    this.setBrowseDate(updatedDate);
  };
  _proto.handleDateTyping = function handleDateTyping(e, fieldName) {
    var data = this.props.data;
    var readOnly = data.readOnly;
    if (readOnly) {
      e.preventDefault();
    } else {
      this.setDateString(e.target.value, fieldName);
    }
  };
  _proto.handleKeyUp = function handleKeyUp(e) {
    var fullWeek = 7;
    var singleDay = 1;
    var tabKey = keyMap.tabKey,
      rightArrow = keyMap.rightArrow,
      upArrow = keyMap.upArrow,
      leftArrow = keyMap.leftArrow,
      downArrow = keyMap.downArrow,
      returnKey = keyMap.returnKey,
      spaceBar = keyMap.spaceBar;
    if (e.which !== tabKey) {
      e.preventDefault();
    }
    var browseDate = this.state.browseDate;
    var updatedBrowseDate = new Date(browseDate);
    var activation = 'browse';
    switch (e.which) {
      case rightArrow:
        updatedBrowseDate.setDate(browseDate.getDate() - singleDay);
        break;
      case upArrow:
        updatedBrowseDate.setDate(browseDate.getDate() - fullWeek);
        break;
      case leftArrow:
        updatedBrowseDate.setDate(browseDate.getDate() + singleDay);
        break;
      case downArrow:
        updatedBrowseDate.setDate(browseDate.getDate() + fullWeek);
        break;
      case returnKey:
        activation = 'active';
        break;
      case spaceBar:
        activation = 'active';
        break;
      default:
      // No action for keypress
    }
    if (activation === 'active') {
      this.setActiveDate(updatedBrowseDate);
    } else {
      this.setBrowseDate(updatedBrowseDate);
    }
  };
  _proto.handleKeyDown = function handleKeyDown(e) {
    if (e.which !== keyMap.tabKey) {
      e.preventDefault();
    }
    var keyboardAccess = this.state.keyboardAccess;
    if (!keyboardAccess) {
      this.setKeyboardAccess(true);
    }
  };
  _proto.handleDateInputFocus = function handleDateInputFocus() {
    this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
      pickerExpanded: true
    }));
  };
  _proto.handleDateInputBlur = function handleDateInputBlur(e) {
    var _this$props2 = this.props,
      handleFieldBlur = _this$props2.handleFieldBlur,
      id = _this$props2.id;
    var activeDate = this.state.activeDate;
    if (handleFieldBlur) {
      handleFieldBlur(activeDate, id, [e.target.className.includes('error') ? 'error' : '']);
    }
  };
  _proto.handleClick = function handleClick(e) {
    var _this$wrapperRef3;
    var pickerExpanded = this.state.pickerExpanded;
    // This function is watching an event on the document to collapse the date picker, push data to parent state and validate
    if ((_this$wrapperRef3 = this.wrapperRef) != null && _this$wrapperRef3.contains(e.target) || pickerExpanded === false) {
      return;
    }
    this.checkAndUpdateInput();
    this.collapsePicker();
  };
  _proto.handleKeyPress = function handleKeyPress(e) {
    var pickerExpanded = this.state.pickerExpanded;
    // This is doing the same as the click hanlder above, just for when users press the escape key
    if (e.keyCode !== keyMap.escKey || pickerExpanded === false) {
      return;
    }
    this.checkAndUpdateInput();
    this.collapsePicker();
  };
  _proto.setBrowseDate = function setBrowseDate(updatedBrowseDate) {
    this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
      browseDate: updatedBrowseDate
    }));
  };
  _proto.setKeyboardAccess = function setKeyboardAccess(keyboardAccessState) {
    this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
      keyboardAccess: keyboardAccessState
    }));
  };
  _proto.setDateString = function setDateString(updatedDateString, fieldName) {
    var _this2 = this;
    this.setState(function () {
      return {
        dateString: updatedDateString
      };
    }, function () {
      var dateString = _this2.state.dateString;
      var _this2$props = _this2.props,
        checkRequired = _this2$props.checkRequired,
        validateAllConstraints = _this2$props.validateAllConstraints,
        updateErrors = _this2$props.updateErrors,
        id = _this2$props.id,
        handleFieldChange = _this2$props.handleFieldChange,
        _this2$props$data = _this2$props.data,
        constraints = _this2$props$data.constraints,
        isRequired = _this2$props$data.isRequired;
      var required = checkRequired(dateString, isRequired);
      var errors = validateAllConstraints(dateString, constraints);
      updateErrors(id, [required].concat(errors));
      handleFieldChange(id, dateString, fieldName); // updating the parent state
    });
  }

  // Callback function to create a ref for the date picker
  ;
  _proto.setWrapper = function setWrapper(node) {
    this.wrapperRef = node;
  };
  _proto.setActiveDate = function setActiveDate(updatedActiveDate, fieldName) {
    var _this3 = this;
    this.setState(function () {
      return {
        activeDate: updatedActiveDate,
        browseDate: updatedActiveDate,
        dateString: _this3.getPrettyDate(updatedActiveDate),
        pickerExpanded: false
      };
    }, function () {
      var dateString = _this3.state.dateString;
      var _this3$props = _this3.props,
        checkRequired = _this3$props.checkRequired,
        validateAllConstraints = _this3$props.validateAllConstraints,
        updateErrors = _this3$props.updateErrors,
        id = _this3$props.id,
        handleFieldChange = _this3$props.handleFieldChange,
        _this3$props$data = _this3$props.data,
        constraints = _this3$props$data.constraints,
        isRequired = _this3$props$data.isRequired;
      var required = checkRequired(dateString, isRequired);
      var errors = validateAllConstraints(dateString, constraints);
      updateErrors(id, [required].concat(errors));
      handleFieldChange(id, dateString, fieldName); // updating the parent state
    });
  };
  _proto.getDelimiter = function getDelimiter(format) {
    return format.indexOf('-') > -1 ? '-' : '/';
  };
  _proto.getPrettyDate = function getPrettyDate(date) {
    var dateDisplayFormat = this.props.config.dateDisplayFormat;
    var format = dateDisplayFormat || 'mm/dd/yyyy';
    var delimiter = this.getDelimiter(format);
    var dateSections = format.split(/\/|-/);
    var dateObj = {
      dd: date.getDate(),
      mm: date.getMonth() + 1,
      yyyy: date.getFullYear()
    };
    return this.prePadDateString("" + dateObj[dateSections[0]] + delimiter + dateObj[dateSections[1]] + delimiter + dateObj[dateSections[2]], delimiter);
  };
  _proto.getDateSections = function getDateSections(dateString, format) {
    var datePositionMap = {
      end: -4,
      middleStart: 3,
      middleLength: 5,
      beginningStart: 0,
      beginningLength: 2
    };
    if (dateString && format === 'mm/dd/yyyy') {
      return {
        year: dateString.slice(datePositionMap.end),
        month: dateString.slice(datePositionMap.beginningStart, datePositionMap.middleLength),
        day: dateString.slice(datePositionMap.middleStart, datePositionMap.beginningLength),
        delimeter: '/'
      };
    }
    if (dateString && format === 'dd-mm-yyyy') {
      return {
        year: dateString.slice(datePositionMap.end),
        month: dateString.slice(datePositionMap.middleStart, datePositionMap.middleLength),
        day: dateString.slice(datePositionMap.beginningStart, datePositionMap.beginningLength),
        delimeter: '-'
      };
    }
    return dateString;
  };
  _proto.clickDateButtonHandler = function clickDateButtonHandler(id, fieldName) {
    var _this4 = this;
    return function (e, selectedDate) {
      e.preventDefault();
      if (selectedDate) {
        _this4.setActiveDate(selectedDate, fieldName);
      }
    };
  };
  _proto.focusDateButtonHandler = function focusDateButtonHandler(e, selectedDate) {
    if (selectedDate) {
      this.setBrowseDate(selectedDate);
    }
  }

  // This function takes the first sunday after epoch and creates a string of letters representing the days of the week in a specific Locale
  ;
  _proto.makeDayNames = function makeDayNames(epochSunday, localeCode) {
    return [0, 1, 1, 1, 1, 1, 1].map(function (day) {
      return new Date(epochSunday.setDate(epochSunday.getDate() + day)).toLocaleString(localeCode, {
        weekday: 'narrow'
      });
    });
  };
  _proto.validate = function validate(value) {
    var _this$props3 = this.props,
      checkRequired = _this$props3.checkRequired,
      validateAllConstraints = _this$props3.validateAllConstraints,
      updateErrors = _this$props3.updateErrors,
      id = _this$props3.id,
      _this$props3$data = _this$props3.data,
      isRequired = _this$props3$data.isRequired,
      constraints = _this$props3$data.constraints;
    var required = checkRequired(value, isRequired);
    var errors = validateAllConstraints(value, constraints);
    updateErrors(id, [required].concat(errors));
  };
  _proto.compareDates = function compareDates(date1, date2) {
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
  };
  _proto.pad = function pad(n) {
    var dateStrLengthRange = {
      max: 10,
      min: 2
    };
    return n < dateStrLengthRange.max && n.length < dateStrLengthRange.min ? "0" + n : n;
  };
  _proto.prePadDateString = function prePadDateString(dateString, format) {
    var desiredDateStringLength = 8;
    if (dateString === '' || dateString.length < desiredDateStringLength) {
      return dateString;
    }
    var delimiter = this.getDelimiter(format);
    var stringSections = dateString.split(/\/|-/);
    if (delimiter === '/') {
      return this.pad(stringSections[0]) + "/" + this.pad(stringSections[1]) + "/" + this.pad(stringSections[2]);
    }
    if (delimiter === '-') {
      return this.pad(stringSections[0]) + "-" + this.pad(stringSections[1]) + "-" + this.pad(stringSections[2]);
    }
    return dateString;
  };
  _proto.stringToDate = function stringToDate(dateString) {
    var config = this.props.config;
    if (!dateString || dateString === '') {
      return 'invalid date';
    }
    var dateParts = this.getDateSections(dateString, config.dateDisplayFormat);
    var dt = new Date();
    dt.setFullYear(parseInt(dateParts.year, 10));
    dt.setMonth(parseInt(dateParts.month, 10) - 1); // because january is month 0
    dt.setDate(parseInt(dateParts.day, 10));
    return dt;
  }

  // This function will be fired each time someone clicks on the field and clicks off or hits escape
  ;
  _proto.checkAndUpdateInput = function checkAndUpdateInput() {
    var _this5 = this;
    var _this$props4 = this.props,
      handleFieldChange = _this$props4.handleFieldChange,
      data = _this$props4.data,
      config = _this$props4.config,
      validateAllConstraints = _this$props4.validateAllConstraints,
      id = _this$props4.id;
    var _this$state2 = this.state,
      dateString = _this$state2.dateString,
      activeDate = _this$state2.activeDate;
    // The prePadDateString will take the user inputed date string, and prepend 0's to the date and month
    var paddedDateString = this.prePadDateString(dateString, config.dateDisplayFormat);
    // The stringToDate will turn padded string into a date object to be operated on
    var inputDate = this.stringToDate(paddedDateString);

    // validateAllConstraints will return an array of errors based on a string
    var errors = validateAllConstraints(paddedDateString, data.constraints);
    // We will check the errors array for an error, if there are any we run the validate function
    // to update the parent state and show an error message and also update the parent state
    // with the value the user entered
    /* eslint-disable-next-line chai-friendly/no-unused-expressions */
    errors.filter(function (error) {
      return error !== '';
    }).length === 0 ? !this.compareDates(activeDate, inputDate) && this.setActiveDate(inputDate) : function () {
      _this5.validate(paddedDateString);
      handleFieldChange(id, paddedDateString);
    }();
  };
  _proto.collapsePicker = function collapsePicker() {
    var _this6 = this;
    this.setState(function () {
      return _objectSpread(_objectSpread({}, _this6.state), {}, {
        pickerExpanded: false
      });
    });
  };
  _proto.isSameArray = function isSameArray(xs, ys) {
    return xs.length === ys.length ? xs.filter(function (x, i) {
      return x !== ys[i];
    }).length === 0 : false;
  };
  _proto.renderPickerBox = function renderPickerBox() {
    var _this$props5 = this.props,
      theme = _this$props5.theme,
      value = _this$props5.value,
      config = _this$props5.config,
      id = _this$props5.id,
      _this$props5$data = _this$props5.data,
      _this$props5$data$wee = _this$props5$data.weekStartDay,
      weekStartDay = _this$props5$data$wee === void 0 ? 0 : _this$props5$data$wee,
      previousLabel = _this$props5$data.previousLabel,
      nextLabel = _this$props5$data.nextLabel,
      fieldName = _this$props5$data.fieldName;
    var _this$state3 = this.state,
      browseDate = _this$state3.browseDate,
      pickerExpanded = _this$state3.pickerExpanded,
      keyboardAccess = _this$state3.keyboardAccess;
    var activeDate = this.stringToDate(value) instanceof Date && !Number.isNaN(this.stringToDate(value)) ? this.stringToDate(value) : new Date();

    // Setup for calendar drop down, getting a localized month name and week day letters
    var previousMonth = new Date(browseDate);
    var nextMonth = new Date(browseDate);
    var epochSunday = new Date('sunday, January 4, 1970 12:00:00 AM');
    var _config$localeCode = config.localeCode,
      localeCode = _config$localeCode === void 0 ? 'en-GB' : _config$localeCode;
    var dayNames = this.makeDayNames(epochSunday, localeCode);
    previousMonth.setMonth(browseDate.getMonth() - 1);
    nextMonth.setMonth(browseDate.getMonth() + 1);
    var panels = {
      previous: {
        dayNames: dayNames,
        month: previousMonth.getMonth(),
        monthName: previousMonth.toLocaleString(localeCode, {
          month: 'long'
        }),
        year: String(previousMonth.getFullYear()),
        weekStartDay: weekStartDay,
        activeDate: activeDate,
        browseDate: browseDate
      },
      current: {
        dayNames: dayNames,
        month: browseDate.getMonth(),
        monthName: browseDate.toLocaleString(localeCode, {
          month: 'long'
        }),
        year: String(browseDate.getFullYear()),
        weekStartDay: weekStartDay,
        activeDate: activeDate,
        browseDate: browseDate
      },
      next: {
        dayNames: dayNames,
        month: nextMonth.getMonth(),
        monthName: nextMonth.toLocaleString(localeCode, {
          month: 'long'
        }),
        year: String(nextMonth.getFullYear()),
        weekStartDay: weekStartDay,
        activeDate: activeDate,
        browseDate: browseDate
      }
    };
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _constructedForm["default"].datePickerPanel + " " + (pickerExpanded ? _constructedForm["default"].isExpanded : '') + " " + (keyboardAccess ? _constructedForm["default"].keyboardAccess : ''),
      onKeyDown: this.handleKeyDown,
      onKeyUp: this.handleKeyUp,
      role: "button",
      tabIndex: 0
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: _constructedForm["default"].previousBtn,
      onClick: this.handlePrevClick,
      type: "button"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      className: _constructedForm["default"].arrowImage,
      src: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='24' height='24' viewBox='0 0 24 24'%3E%3Cdefs%3E%3Cpath id='a' d='M12.5 13.563L6.762 8 5 9.712 12.5 17 20 9.712 18.237 8z'/%3E%3C/defs%3E%3Cuse fill-rule='evenodd' xlink:href='%23a'/%3E%3C/svg%3E",
      alt: previousLabel
    })), /*#__PURE__*/_react["default"].createElement("button", {
      className: _constructedForm["default"].nextBtn,
      onClick: this.handleNextClick,
      type: "button"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      className: _constructedForm["default"].arrowImage,
      src: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='24' height='24' viewBox='0 0 24 24'%3E%3Cdefs%3E%3Cpath id='a' d='M12.5 13.563L6.762 8 5 9.712 12.5 17 20 9.712 18.237 8z'/%3E%3C/defs%3E%3Cuse fill-rule='evenodd' xlink:href='%23a'/%3E%3C/svg%3E",
      alt: nextLabel
    })), /*#__PURE__*/_react["default"].createElement(_calendarPanel["default"], {
      data: panels.current,
      clickDateButtonHandler: this.clickDateButtonHandler(id, fieldName),
      focusDateButtonHandler: this.focusDateButtonHandler,
      theme: theme
    }));
  };
  _proto.render = function render() {
    var _this7 = this;
    var _this$props6 = this.props,
      theme = _this$props6.theme,
      _this$props6$errorMes = _this$props6.errorMessages,
      errorMessages = _this$props6$errorMes === void 0 ? [''] : _this$props6$errorMes,
      id = _this$props6.id,
      _this$props6$data = _this$props6.data,
      fieldName = _this$props6$data.fieldName,
      fieldLabel = _this$props6$data.fieldLabel,
      requiredMessage = _this$props6$data.requiredMessage,
      isRequired = _this$props6$data.isRequired;
    var _this$state4 = this.state,
      dateString = _this$state4.dateString,
      isOverField = _this$state4.isOverField;
    var randomIdModifier = 999;
    var errors = errorMessages.filter(function (error) {
      return error !== '';
    });
    var constraintError = errors.length > 0 && errors[0] !== 'requiredMessage';
    var inputId = Math.floor(Math.random() * randomIdModifier);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _constructedForm["default"].formField,
      key: fieldName,
      ref: this.setWrapper
    }, /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: fieldName + "-" + inputId,
      className: _constructedForm["default"].fieldLabel + " " + theme.labelSmall + " " + (isOverField ? _constructedForm["default"].isOverField : '')
    }, fieldLabel && fieldLabel.trim(), isRequired && /*#__PURE__*/_react["default"].createElement("span", {
      className: _constructedForm["default"].requiredNotification
    }, "*")), /*#__PURE__*/_react["default"].createElement("input", {
      className: theme.inputsAndOptions + " " + _constructedForm["default"].textField + " " + (errors.length !== 0 ? _constructedForm["default"].error : ''),
      name: fieldName,
      id: fieldName + "-" + inputId,
      type: "text",
      required: isRequired,
      "aria-invalid": constraintError,
      "aria-describedby": errors.length !== 0 && fieldName + "-error-" + id.join('-'),
      autoComplete: "nonOffString-" + inputId,
      value: dateString,
      onChange: function onChange(e) {
        return _this7.handleDateTyping(e, fieldName);
      },
      onFocus: this.handleDateInputFocus,
      onBlur: this.handleDateInputBlur
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: theme.mmcIconCalendar + " " + _constructedForm["default"].calendarIconPosition
    }), this.renderPickerBox(), errorMessages[0] === 'requiredMessage' ? /*#__PURE__*/_react["default"].createElement(_errorMessage["default"], {
      message: requiredMessage,
      theme: theme,
      errorLabel: fieldName + "-error-" + id.join('-'),
      role: 'alert'
    }) : errorMessages.filter(function (error) {
      return error !== '';
    }).map(function (message, i) {
      return /*#__PURE__*/_react["default"].createElement(_errorMessage["default"], {
        key: i,
        message: message,
        theme: theme,
        errorLabel: fieldName + "-error-" + id.join('-')
      });
    }));
  };
  return DatePicker;
}(_react["default"].Component);
exports["default"] = DatePicker;
DatePicker.displayName = 'DatePicker';
DatePicker.defaultProps = {
  data: _constructedForm2["default"].formComponents[5],
  theme: {}
};